class ProcedureGroup extends HTMLElement {
  connectedCallback() {
    const init = () => {
      const spinner = this.querySelector('.procedure-group__spinner');
      const panels = this.querySelectorAll('.procedure-item');
      const select = this.querySelector('.procedure-group__select');
      if (!panels.length || !select) { spinner?.remove(); return; }

      panels.forEach((p, i) => {
        p.setAttribute('role', 'region');
        p.setAttribute('aria-label', p.dataset.procedureTitle);

        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = p.dataset.procedureTitle;
        select.appendChild(opt);
      });

      select.addEventListener('change', () => {
        this._select(panels, select, Number(select.value));
      });

      spinner?.remove();
      this.classList.add('initialized');
      this.querySelector('.procedure-group__panels')?.removeAttribute('aria-busy');
      this._select(panels, select, 0);

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', ({ target }) => {
          const i = [...panels].indexOf(target.closest('.procedure-item'));
          if (i >= 0) this._select(panels, select, i);
        });
      }
    };

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init, { once: true })
      : init();
  }

  _select(panels, select, index) {
    panels.forEach((p, i) => p.classList.toggle('active', i === index));
    select.value = index;
  }
}
customElements.get('procedure-group') || customElements.define('procedure-group', ProcedureGroup);
